export function splitColumns(items: any[]) {
    return items.reduce(
        (a, c, i, self) => {
            const splitIndex = self.findIndex(
                (x) => x.type && x.type === 'ColumnBreak'
            );
            const temp = [...a];

            if (i < splitIndex) {
                temp[0].push(c);
            } else if (i > splitIndex) {
                temp[1].push(c);
            }

            return temp;
        },
        [[], []]
    );
}

import { IGroupedItems } from '.';

export function groupLists(column: any[]) {
    const groupedItems: IGroupedItems[] = [];

    column.forEach((item, index) => {
        // TODO what if first item has no group header?

        if (item.type && item.type === 'GroupHeader') {
            const newGroup = { ...item, items: [] };
            groupedItems.push(newGroup);
        } else if (groupedItems.length === 0) {
            groupedItems.push({
                caption: 'unknown',
                items: [ { ...item } ]
            });
        } else {
            groupedItems[groupedItems.length - 1].items.push({ ...item });
        }
    });

    return groupedItems;
}
